import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';

const BuyOneClickButton = (props) => {
  const handleBuyClick = (event) => {
    event.currentTarget.setAttribute('disabled', 'disabled');
    props.onClick();
  };

  return <Button size="sm" variant='outline-dark' className='mr-2' title={ gettext('Купить в один клик') }
                 onClick={ handleBuyClick }>
    <span className="icon icon-credit-card"></span> { gettext('Купить') }
  </Button>
};

BuyOneClickButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default BuyOneClickButton;